import Vue from 'vue'
import Router from 'vue-router'
import Callback from '@/components/Callback'
import BaseVehicles from '@/components/BaseVehicles'
import BaseGeofences from '@/components/BaseGeofences'
import BaseAlerts from '@/components/BaseAlerts'
import AppVehicleViewer from '@/components/AppVehicleViewer'
import VehicleCRUD from '@/components/VehicleCRUD'
import AgenciesCRUD from '@/components/AgenciesCRUD'
import ReportGenerator from '@/components/ReportGenerator'
import KPI from '@/components/KPI'

import CreateGeofenceView from '@/components/Geofence/CreateGeofenceView'
// import CreateMissionView from '@/components/Missions/CreateMissionView'
// import EditGeofenceView from '@/components/Geofence/EditGeofenceView'

import requireAuth from './authMiddleware'

import MissionsServices from '@/components/Missions/MissionsServices'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'BaseVehicles',
      component: BaseVehicles,
      beforeEnter: requireAuth,
      meta: {
        restriction: []
      }
    },
    {
      path: '/vehicles/:vehicle_id',
      name: 'AppVehicleViwer',
      component: AppVehicleViewer,
      beforeEnter: requireAuth,
      meta: {
        restriction: []
      }
    },
    {
      path: '/vehicles-crud',
      name: 'VehicleCRUD',
      component: VehicleCRUD,
      beforeEnter: requireAuth,
      meta: {
        restriction: [23, 1, 15, 74, 77, 78]
      }
    },
    {
      path: '/agencies',
      name: 'AgenciesCRUD',
      component: AgenciesCRUD,
      beforeEnter: requireAuth,
      meta: {
        restriction: []
      }
    },
    {
      path: '/geofences',
      name: 'BaseGeofences',
      component: BaseGeofences,
      beforeEnter: requireAuth,
      meta: {
        // restriction: [23, 1, 15, 74, 77, 78, 115]
        restriction: []
      }
    },
    {
      path: '/geofences/create',
      name: 'CreateGeofenceView',
      component: CreateGeofenceView,
      beforeEnter: requireAuth,
      meta: {
        restriction: [23, 1, 15, 74, 77, 78, 115]
      }
    },
    // {
    //   path: '/geofences/:geofence_id/edit',
    //   name: 'EditGeofenceView',
    //   component: EditGeofenceView,
    //   beforeEnter: requireAuth,
    //   meta: {
    //     // restriction: [23, 1, 15, 74, 77, 78, 115]
    //     restriction: []
    //   }
    // },
    {
      path: '/missions/services',
      name: 'missions-services',
      component: MissionsServices,
      beforeEnter: requireAuth,
      meta: {
        restriction: [23]
      }
    },
    // {
    //   path: '/missions/create',
    //   name: 'CreateMissionView',
    //   component: CreateMissionView,
    //   beforeEnter: requireAuth,
    //   meta: {
    //     restriction: [23, 1, 15, 74, 77, 78]
    //     // restriction: [23, 15, 74, 77, 78]
    //   }
    // },
    {
      path: '/alerts',
      name: 'BaseAlerts',
      component: BaseAlerts,
      beforeEnter: requireAuth,
      meta: {
        restriction: []
      }
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/reports',
      name: 'ReportGenerator',
      component: ReportGenerator,
      beforeEnter: requireAuth,
      meta: {
        restriction: [23, 1, 15, 74, 77, 78]
      }
    },
    {
      path: '/k-p-i',
      name: 'KPI',
      component: KPI,
      beforeEnter: requireAuth,
      meta: {
        restriction: [23, 1, 15, 74, 77, 78]
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js